<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>
  <div
    v-if="
      !this.$router.currentRoute.value.path.includes('panel') &&
      !this.$router.currentRoute.value.path.includes('login') &&
      this.$store.getters.isAuthenticated
    "
    class="serviceButtonContainer"
  >
    <a
      ID="serviceBtn"
      class="btn btn-facebook btn-sidebar-toggle"
      @click="serviceBtnClick"
    >
      <div
        class="position-absolute fs-7 bg-light text-dark rounded shadow px-2"
        style="
          width: 140px;
          top: -30px;
          right: -48px;
          box-shadow: -2px -1px 10px black !important;
        "
      >
        خدمات ارگانیک‌‌ مایندد
        <i
          class="fi fi-arrow-down-full text-light"
          style="position: absolute; left: 45%; top: 55%"
        ></i>
      </div>
      <svg
        width="25px"
        height="25px"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        class="bi bi-card-checklist"
        viewBox="0 0 16 16"
      >
        <path
          d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
        ></path>
        <path
          d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
        ></path>
      </svg>
    </a>
  </div>

  <site-modal
    ID="certificateModal"
    modalSize="large"
    @Closed="closedCertificateModal"
  >
    <template #header>
      <h6>مجوز‌ها</h6>
    </template>
    <template #body>
      <div>
        <div
          id="carouselIndicators"
          class="carousel slide carousel-dark"
          data-bs-ride="carousel"
        >
          <!-- <div class="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselIndicators"
              data-bs-slide-to="0"
              class="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselIndicators"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselIndicators"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div> -->
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img
                src="../../../assets/images/siteImages/Certificates/1-Cert.jpg"
                class="d-block w-100"
                alt="پروانه اشتغال تخصصی دکتر بهزاد چاوشی"
              />
            </div>
            <div class="carousel-item">
              <img
                src="../../../assets/images/siteImages/Certificates/2-Cert.jpg"
                class="d-block w-100"
                alt="پروانه تاسیس مرکز تخصصی مشاوره ازدواج و خانواده دکتر بهزاد چاوشی"
              />
            </div>
            <div class="carousel-item">
              <img
                src="../../../assets/images/siteImages/Certificates/3-Cert.jpg"
                class="d-block w-100"
                alt="پروانه فعالیت مسئول فنی دکتر بهزاد چاوشی"
              />
            </div>
            <div class="carousel-item">
              <img
                src="../../../assets/images/siteImages/Certificates/4-Cert.jpg"
                class="d-block w-100 h-100"
                alt="پروانه تاسیس مرکز خدمات روان شناسی و مشاوره دکتر بهزاد چاوشی"
              />
            </div>
            <!-- <div class="carousel-item">
              <img
                src="../../../assets/images/siteImages/Certificates/5-Cert.jpg"
                class="d-block w-100"
                alt="پروانه اشتغال تخصصی دکتر محمد اسدی"
              />
            </div> -->
            <!-- <div class="carousel-item">
              <img
                src="../../../assets/images/siteImages/Certificates/4-Cert.jpg"
                class="d-block w-100"
                alt="پروانه فعالیت مسئول فنی دکتر محمد اسدی"
              />
            </div>
            <div class="carousel-item">
              <img
                src="../../../assets/images/siteImages/Certificates/5-Cert.jpg"
                class="d-block w-100"
                alt="پروانه اشتغال تخصصی دکتر محمد اسدی"
              />
            </div> -->
          </div>

          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselIndicators"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselIndicators"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </template>
    <template #footer>
      <div></div>
    </template>
  </site-modal>
  <site-modal
    ID="reservingModal"
    modalSize="semiMedium"
    @closed="closedReservingModal"
    :modalClass="isDiscountSessionsModalShown ? 'hideModal' : 'showModal'"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="24px"
            height="24px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-clock-history"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
            ></path>
            <path
              d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
            ></path>
            <path
              d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
            ></path>
          </svg>
          ثبت جلسه
        </h6>
      </div>
    </template>
    <template #body>
      <div
        class="alert alert-danger text-center"
        role="alert"
        v-if="discountTariffPriceList.length != 0"
      >
        <strong
          class="blinkText"
          style="cursor: pointer"
          @click="showDiscountSessionsModal"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-percent"
            viewBox="0 0 16 16"
          >
            <path
              d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
            ></path>
          </svg>
          تخفیف
        </strong>
      </div>
      <div v-if="reservingModalStatus == 'search'">
        <p class="mb-2">لطفا اطلاعات زیر را تکمیل نمایید.</p>
        <div
          v-for="(instance, index) in priceEntity"
          :key="index"
          class="alert alert-success text-center"
        >
          قیمت جلسات
          <b>{{ instance.therapyTypeTitle }}</b>
          با شیوه برگزاری
          <b class="ms-1">{{ instance.sessionTypeTitle }}</b>

          و مدت زمان
          <b>{{ instance.duration }}</b>
          دقیقه
          <b>{{ thousandSeprator(instance.price, ',', '.') }}</b>
          <b>{{ instance.currencyTypeTitle }}</b>
          می‌باشد.
        </div>
        <div class="d-flex justify-content-center row">
          <div class="col" :class="isMobile ? 'col-9' : 'col-7'">
            <combo-Box-With-Message
              ref="therapyTypeInput"
              warningSelectRow=""
              errorText="انتخاب نوع جلسه الزامی است."
              topTitleClass="mb-1"
              topTitle="نوع درمان:"
              comboClass="text-end mt-1"
              @comboOnChanged="therapyTypeChanged"
              :required="true"
              :comboList="therapyTypeList"
              v-model:selectedItem="reservingEntity.therapyTypeID"
              itemKey="id"
              itemValue="title"
              comboSize="sm"
            />
            <combo-Box-With-Message
              ref="sessionTypeInput"
              warningSelectRow=""
              errorText="انتخاب شیوه برگزاری الزامی است."
              topTitleClass="mb-1"
              topTitle="شیوه برگزاری:"
              :disabled="
                isSessionTypeSelectDisabled ||
                (this.$store.getters.isOverseas == true &&
                  this.$store.getters.isAuthenticated)
              "
              comboClass="text-end mt-1"
              @comboOnChanged="sessionTypeChanged"
              :required="true"
              :comboList="sessionTypeList"
              v-model:selectedItem="reservingEntity.sessionTypeID"
              itemKey="id"
              itemValue="title"
              comboSize="sm"
            />
            <searchable-input
              :required="reservingEntity.therapyTypeID == 1"
              errorClass="errorClass text-danger"
              ref="scopeInput"
              :disabled="isScopeSelectDisabled"
              errorText="انتخاب حوزه الزامی است."
              :options="scopeList"
              v-model:inputValue="reservingEntity.scopeIDs"
              :hasSideBox="false"
              topTitle="نوع تخصص:"
              :canDeselect="false"
              topTitleClass="mb-1"
            />
          </div>
        </div>
      </div>
      <div v-if="reservingModalStatus == 'result'">
        <!-- v-if="this.showReservingEntity.date != ''"  -->
        <div class="justified">
          <div class="">
            <p class="">
              <a
                href="#"
                @click="returnBackStep"
                class="text-decoration-none link-muted fs13px collapsed"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="accordionAccountSignIn"
              >
                <svg
                  width="18px"
                  height="18px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-arrow-right-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                  ></path>
                </svg>
                بازگشت
              </a>
            </p>
          </div>
          <div>
            <!-- اولین جلسه قابل ثبت برای شما از تاریخ
            <b class="text-danger">{{
              getFullPersianDate(this.showReservingEntity.date)
            }}</b>
            به بعد قابل دسترسی است. -->
            <template v-if="!this.$store.getters.isAuthenticated">
              به منظور ادامه فرآیند لطفا وارد حساب کاربری خود شوید.
            </template>
          </div>
        </div>
        <!-- <div v-else>
          <p>
            <a
              href="#"
              @click="returnBackStep"
              class="text-decoration-none link-muted fs13px collapsed"
              data-bs-toggle="collapse"
              aria-expanded="false"
              aria-controls="accordionAccountSignIn"
              ><svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-arrow-right-circle-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                ></path>
              </svg>
              بازگشت
            </a>
          </p>
          مراجع گرامی متاسفانه با توجه به فیلتر های انتخابی شما جلسه‌ای به منظور
          رزرو <b>وجود ندارد</b>.
        </div> -->
      </div>
    </template>
    <template #footer>
      <div
        class="text-center mt-2 w-100"
        v-if="reservingModalStatus == 'result'"
      >
        <button
          class="btn btn-blueSite w-50"
          @click="goToLoginOrReservePage"
          v-if="!this.$store.getters.isAuthenticated"
        >
          <span>ورود | ثبت نام</span>
        </button>
        <button
          class="btn btn-blueSite w-50"
          @click="goToLoginOrReservePage"
          v-if="
            this.$store.getters.isAuthenticated &&
            this.showReservingEntity.date != ''
          "
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-clock-history ms-2"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
            ></path>
            <path
              d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
            ></path>
            <path
              d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
            ></path>
          </svg>
          <span>ثبت جلسه</span>
        </button>
      </div>
      <div
        class="col col-12 text-center"
        v-if="reservingModalStatus == 'search'"
      >
        <button class="btn btn-blueSite col-7" @click="searchButton">
          <span>جستجو</span>
        </button>
      </div>
    </template>
  </site-modal>
  <site-modal
    ID="reservingTestModal"
    modalSize="semiMedium"
    @closed="closedReservingTestModal"
    :modalClass="isDiscountSessionsModalShown ? 'hideModal' : 'showModal'"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="25px"
            height="25px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-journal-check"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
            ></path>
            <path
              d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
            ></path>
            <path
              d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
            ></path>
          </svg>
          ثبت تست
        </h6>
      </div>
    </template>
    <template #body>
      <div
        class="alert alert-danger text-center"
        role="alert"
        v-if="discountTariffPriceList.length != 0"
      >
        <strong
          class="blinkText"
          style="cursor: pointer"
          @click="showDiscountSessionsModal"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-percent"
            viewBox="0 0 16 16"
          >
            <path
              d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
            ></path>
          </svg>
          تخفیف
        </strong>
      </div>
      <div v-if="reservingTestModalStatus == 'search'">
        <p class="mb-2">
          لطفا به منظور دریافت وقت
          <b>جلسه تست</b>
          اقلام اطلاعاتی زیر را تکمیل نمایید.
        </p>
        <div
          v-for="(instance, index) in priceEntity"
          :key="index"
          class="alert alert-success text-center"
        >
          قیمت جلسات
          <b>{{ instance.therapyTypeTitle }}</b>
          با شیوه برگزاری
          <b class="ms-1">{{ instance.sessionTypeTitle }}</b>

          و مدت زمان
          <b>{{ instance.duration }}</b>
          دقیقه
          <b>{{ thousandSeprator(instance.price, ',', '.') }}</b>
          <b>{{ instance.currencyTypeTitle }}</b>
          می‌باشد.
        </div>
        <div class="d-flex justify-content-center row">
          <div class="col" :class="isMobile ? 'col-11' : 'col-8'">
            <combo-Box-With-Message
              ref="sessionTypeForTestInput"
              warningSelectRow=""
              errorText="انتخاب شیوه برگزاری الزامی است."
              topTitleClass="mb-1"
              topTitle="شیوه برگزاری:"
              :disabled="
                this.$store.getters.isOverseas == true &&
                this.$store.getters.isAuthenticated
              "
              @comboOnChanged="sessionTypeForTestChanged"
              comboClass="text-end mt-1"
              :required="true"
              :comboList="sessionTypeList"
              v-model:selectedItem="reservingTestEntity.sessionTypeID"
              itemKey="id"
              itemValue="title"
              comboSize="sm"
            />
            <searchable-input
              mode="single"
              ref="testTypeInput"
              placeHolder=""
              errorText="انتخاب نام تست الزامی است."
              :required="true"
              :options="testTypeList"
              v-model:inputValue="reservingTestEntity.testTypeID"
              :hasSideBox="false"
              topTitle="نام تست:"
              :canDeselect="false"
              topTitleClass="mt-1"
              :disabled="this.reservingTestEntity.sessionTypeID == 0"
            />
          </div>
        </div>
      </div>
      <div v-if="reservingTestModalStatus == 'result'">
        <!-- v-if="this.showReservingEntity.date != ''" -->
        <div class="justified">
          <div class="">
            <p class="">
              <a
                href="#"
                @click="returnTestBackStep"
                class="text-decoration-none link-muted fs13px collapsed"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="accordionAccountSignIn"
              >
                <svg
                  width="18px"
                  height="18px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-arrow-right-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                  ></path>
                </svg>
                بازگشت
              </a>
            </p>
          </div>
          <div>
            <!-- اولین جلسه تست خالی و قابل رزرو برای شما از تاریخ
            <b class="text-danger">{{
              getFullPersianDate(this.showReservingEntity.date)
            }}</b>
            به بعد قابل دسترسی است. -->
            <template v-if="!this.$store.getters.isAuthenticated">
              به منظور ادامه فرآیند رزرو وارد حساب کاربری خود شوید.
            </template>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="col col-12 text-center">
        <div
          class="text-center mt-2 w-100"
          v-if="reservingTestModalStatus == 'result'"
        >
          <button
            class="btn btn-blueSite w-50"
            @click="goToLoginOrReserveTestPage"
            v-if="!this.$store.getters.isAuthenticated"
          >
            <span>ورود | ثبت نام</span>
          </button>
          <button
            class="btn btn-blueSite w-50"
            @click="goToLoginOrReserveTestPage"
            v-if="
              this.$store.getters.isAuthenticated &&
              this.showReservingEntity.date != ''
            "
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-clock-history ms-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
              ></path>
              <path
                d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
              ></path>
              <path
                d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
              ></path>
            </svg>
            <span>ثبت جلسه</span>
          </button>
        </div>

        <button
          class="btn btn-blueSite col-5"
          v-if="reservingTestModalStatus == 'search'"
          @click="searchTestSessionButton"
        >
          <span>جستجو</span>
        </button>
        <button
          v-if="reservingTestModalStatus == 'search'"
          class="btn btn-warning col-2"
          @click="openTestInformation"
          :class="isMobile ? 'px-1' : ''"
        >
          <span> راهنما </span>
        </button>
      </div>
    </template>
  </site-modal>

  <site-modal
    ID="discountSessionsModal"
    modalSize="medium"
    @closed="discountSessionsModalClosed"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-percent"
            viewBox="0 0 16 16"
          >
            <path
              d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
            ></path>
          </svg>
          لیست تخفیفات
        </h6>
      </div>
    </template>
    <template #body>
      <p>
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-exclamation-lg"
          viewBox="0 0 16 16"
        >
          <path
            d="M7.005 3.1a1 1 0 1 1 1.99 0l-.388 6.35a.61.61 0 0 1-1.214 0L7.005 3.1ZM7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
          ></path>
        </svg>
        لیست جلسات دارای
        <b>تخفیف</b>
        مطابق جدول است.
      </p>
      <table class="table" v-if="discountTariffPriceList.length != 0">
        <thead class="table-primary">
          <tr>
            <th scope="col">#</th>
            <th scope="col">نوع درمان</th>
            <th scope="col">شیوه برگزاری</th>
            <th
              scope="col"
              v-if="discountTariffPriceList.some((a) => a.scopeTitle != null)"
            >
              حوزه
            </th>
            <th
              scope="col"
              v-if="discountTariffPriceList.some((a) => a.topicTitle != null)"
            >
              موضوع
            </th>
            <th scope="col">قیمت</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in discountTariffPriceList" :key="index">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ item.therapyTypeTitle }}</td>
            <td>{{ item.sessionTypeTitle }}</td>
            <td
              v-if="discountTariffPriceList.some((a) => a.scopeTitle != null)"
            >
              {{ item.scopeTitle == null ? 'تمام حوزه‌ها' : item.scopeTitle }}
            </td>
            <td
              v-if="discountTariffPriceList.some((a) => a.topicTitle != null)"
            >
              {{ item.topicTitle == null ? 'تمام موضوعات' : item.topicTitle }}
            </td>
            <td>
              {{ thousandSeprator(item.price, ',', '.') }}
              {{ item.currencyTypeTitle }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template #footer>
      <div class="col col-12 text-center">
        <button
          class="btn btn-sm rounded btn-blueSite"
          @click="discountSessionsModalClosed"
        >
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
      </div>
    </template>
  </site-modal>

  <site-modal
    ID="logoutConformationModal"
    modalSize="semiMedium"
    @closed="logoutConfirmationClosed"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            class="bi bi-box-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"
            />
            <path
              fill-rule="evenodd"
              d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"
            />
          </svg>
          خروج
        </h6>
      </div>
    </template>
    <template #body>
      <p>آیا برای خروج از حساب کاربری خود اطمینان دارید؟</p>
    </template>
    <template #footer>
      <div class="d-flex w-100 justify-content-between">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="confirmedLogout()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          بلی
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="logoutConfirmationClosed()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          خیر
        </button>
      </div>
    </template>
  </site-modal>

  <site-modal
    ID="mainChooseClientModal"
    modalSize="semiMedium"
    modalHeaderClass="bg-gray-700 text-yellowTheme"
    @closed="cancelMainChooseClientModal"
    modalFooterClass="border-0 p-0 m-0 d-none"
  >
    <template #header>
      <div class="row">
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-person-check-fill ms-2"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
            ></path>
            <path
              d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
            ></path>
          </svg>
          انتخاب شناسه کاربری
        </h6>
      </div>
    </template>
    <template #body>
      <div>مایل هستید با کدام حساب کاربری ادامه دهید؟</div>
      <div class="row">
        <div
          class="col-6 p-0 m-0 px-4 py-2"
          v-for="item in getClientList()"
          :key="item.personID"
        >
          <div
            class="card shadow text-center bg-gray-200 pointer transition-hover-bottom"
            @click="this.chooseClientButtonClick(item)"
          >
            <div class="card-body">
              <!-- <svg
                width="30px"
                height="30px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-person-check"
                viewBox="0 0 16 16"
              >
                <path
                  d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                ></path>
                <path
                  fill-rule="evenodd"
                  d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                ></path>
              </svg> -->
              <div>{{ item.firstName }} {{ item.lastName }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="text-center w-100"></div>
    </template>
  </site-modal>

  <site-modal
    ID="contactUsModal"
    modalSize="medium"
    @closed="cancelContactUsModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="24px"
            height="24px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-envelope-plus"
            viewBox="0 0 16 16"
          >
            <path
              d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"
            ></path>
            <path
              d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
            ></path>
          </svg>
          ارتباط با ما
        </h6>
      </div>
    </template>
    <template #body>
      <!-- <div class="small">
        با ارسال نظرات و پیشنهادات خود، ما را در ارتقاء کیفیت خدمات یاری نمایید
      </div> -->

      <div class="col-12">
        <validation-summery
          v-if="formHasError"
          :errors="formError"
        ></validation-summery>
        <div class="bg-mainPanel p-3 p-lg-3 rounded">
          <div class="form-floating mb-3">
            <floating-input-with-message
              containerClass="mb-3"
              inputType="text"
              ref="clientCodeInput"
              inputPlaceHolder="ClientCode"
              v-model:inputValue="entity.clientCode"
              labelClass="text-muted small"
              labelValue="شماره عضویت"
              errorMessage="وارد کردن شماره عضویت الزامی است"
              erroMessageClass="smaller text-danger"
              :disable-input="true"
            />
          </div>

          <div class="form-floating mb-3">
            <floating-input-with-message
              containerClass="mb-3"
              inputType="text"
              ref="nameInput"
              inputPlaceHolder="Username"
              v-model:inputValue="entity.name"
              labelClass="text-muted small"
              labelValue="نام و نام خانوادگی"
              errorMessage="وارد کردن نام الزامی است"
              erroMessageClass="smaller text-danger"
              :disable-input="true"
            />
          </div>
          <div class="form-floating mb-3">
            <floating-input-with-message
              containerClass="mb-3"
              inputType="text"
              ref="emailInput"
              inputPlaceHolder="Username"
              v-model:inputValue="entity.email"
              labelClass="text-muted small"
              labelValue="ایمیل"
              errorMessage="ایمیل را به درستی وارد نمایید"
              erroMessageClass="smaller text-danger"
            />
          </div>
          <div class="form-floating mb-3">
            <floating-input-with-message
              containerClass="mb-3"
              inputType="text"
              ref="phoneInput"
              inputPlaceHolder="Username"
              v-model:inputValue="entity.phone"
              labelClass="text-muted small"
              labelValue="تلفن همراه"
              errorMessage="شماره همراه را به درستی وارد نمایید "
              erroMessageClass="smaller text-danger"
            />
          </div>
          <div class="form-floating mb-3">
            <floating-input-with-message
              containerClass="mb-3"
              inputType="text"
              ref="subjectInput"
              inputPlaceHolder="Username"
              v-model:inputValue="entity.subject"
              labelClass="text-muted small"
              labelValue="عنوان موضوع مورد نظر خود را وارد کنید"
              errorMessage="وارد کردن موضوع الزامی است"
              erroMessageClass="smaller text-danger"
            />
          </div>
          <div class="form-floating mb-3">
            <textarea
              id="descriptionInput"
              ref="descriptionInput"
              name="contact_message"
              class="form-control"
              :class="{ isNotValid: !validatedMessage }"
              rows="3"
              style="min-height: 120px"
              @input="messsageInput"
              v-model="entity.message"
              maxlength="500"
            ></textarea>
            <label class="text-muted small px-0" for=""
              >متن پیام خود را تایپ کنید</label
            >
            <div>
              <span class="smaller text-gray-600">
                تعداد {{ remainChar }} کارکتر باقی مانده است
              </span>
            </div>
            <div>
              <span v-if="!validatedMessage" class="smaller text-danger">
                وارد کردن متن پیام الزامی است
              </span>
            </div>
          </div>

          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="fa fa-paperclip"></i
              ></span>
              <input
                class="form-control form-control-sm custom-file-upload custom-file-upload-hidden"
                data-btn-text="انتخاب"
                id="formFile"
                name="formFile"
                type="file"
                @input="fileReceiptInput"
                value=""
                tabindex="-1"
                style="position: absolute"
              />
              <input
                type="text"
                id="inputFileName"
                ref="inputFileName"
                disabled
                class="form-control form-control-sm file-upload-input text-left"
              />
              <span class="me-1 input-group-btn" tabindex="-1">
                <button class="btn btn-sm btn-light ps-2" id="btnUpload">
                  <i class="fi fi-attachment"></i>
                </button>
              </span>
            </div>

            <span
              class="field-validation-valid text-danger"
              data-valmsg-for="Attachment"
              data-valmsg-replace="true"
            ></span>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="m-auto">
        <button
          class="btn btn-sm rounded btn-danger"
          @click="confirmedContactUsModal"
        >
          <i class="fi fi-box-checked"></i>
          ثبت
        </button>
        <button
          class="btn btn-sm rounded btn-blueSite"
          @click="cancelContactUsModal"
        >
          <i class="fi fi-close"></i>
          انصراف
        </button>
      </div>
    </template>
  </site-modal>

  <site-modal
    ID="priceInformationModal"
    modalSize="medium"
    @closed="cancelPriceInformationModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-cash-stack"
            viewBox="0 0 16 16"
          >
            <path
              d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
            ></path>
            <path
              d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z"
            ></path>
          </svg>
          اطلاع از قیمت جلسات
        </h6>
      </div>
    </template>
    <template #body>
      <table class="table">
        <thead class="table-primary">
          <tr>
            <th scope="col">#</th>
            <th scope="col">
              {{ sessionPricecMode != 'test' ? 'درمان' : 'تست' }}
            </th>
            <th scope="col">شیوه</th>
            <th scope="col">تعرفه</th>
            <th scope="col">قیمت</th>
            <th scope="col" v-if="sessionPricecMode != 'test'">دقیقه</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(instance, index) in priceEntity" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ instance.therapyTypeTitle }}</td>
            <td>{{ instance.sessionTypeTitle }}</td>
            <td v-if="instance.tariffTypeID == 1">عادی</td>
            <td v-if="instance.tariffTypeID == 2">
              <b class="text-danger">تخفیف</b>
            </td>
            <td>
              {{ thousandSeprator(instance.price, ',', '.') }}
              {{ instance.currencyTypeTitle }}
            </td>
            <td v-if="sessionPricecMode != 'test'">{{ instance.duration }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template #footer>
      <div class="m-auto">
        <button
          class="btn btn-sm rounded btn-blueSite"
          @click="cancelPriceInformationModal"
        >
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
      </div>
    </template>
  </site-modal>

  <site-modal
    ID="testInformationModal"
    modalSize="medium"
    @closed="closeTestInformation"
  >
    <template #header>
      <h6>
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-info-square"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          ></path>
          <path
            d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
          ></path>
        </svg>
        راهنما
      </h6>
    </template>
    <template #body>
      <div>
        <p class="justified">
          مراجع گرامی، راهنمای استفاده از انواع تست‌ها به شرح زیر می‌باشد:
        </p>
        <p class="justified">
          <strong>1. تست دامنه توجه IVA-2:</strong>
          جلسات ارزیابی دامنه توجه به دو صورت حضوری و غیرحضوری برگزار می‌شود. در
          جلسات حضوری علاوه بر مصاحبه تشخیصی توسط متخصص روانشناس، تست کامپیوتری
          بسیار معتبر IVA-2 نیز اجرا خواهد شد. در جلسات غیرحضوری متخصص مربوطه با
          شما مصاحبه بالینی دقیقی را انجام می‌دهد و طبق دستورالعمل‌ها، تک به تک
          علائم را با شما چک می‌کند و نهایتا نتیجه تشخیص و راه حل درمانی مشکل را
          خدمتت شما ارائه خواهد داد. این تست برای کودکان پنج سال تا افراد هشتاد
          سال قابل اجراست و نتیجه تست حضوری با مصاحبه غیرحضوری از لحاظ دقت
          تشخیصی و بالینی تفاوتی ندارد.
        </p>
        <p class="justified">
          <strong>2. تست قصه عشق LSS:</strong>
          یک ابزار بسیار مفید برای خودشناسی و انتخاب دقیق در روابط عاطفی محسوب
          می شود که براساس جدیدترین نظریه رابرت استرنبرگ روانشناس مشهور آمریکایی
          در زمینه روابط عاطفی طراحی و ساخته شده است. این تست مختص افراد ۱۸ سال
          به بالا هست. تعداد سوالات این تست ۱۰۰ و زمان تقریبی پاسخدهی به آن ۲۵
          دقیقه می باشد.
        </p>

        <p class="justified">
          <strong>3. تست اختلالات روانی MMPI:</strong>
          جامع ترین و معروفترین تست در روانشناسی محسوب می شود که اطلاعات بسیار
          دقیقی در زمینه ابعاد مختلف شخصیت و وضعیت سلامت روان در اختیار قرار می
          دهد. این تست برای افراد ۱۶ سال به بالا قابل اجرا می باشد. تعداد سوالات
          این تست ۵۶۷ و زمان تقریبی پاسخدهی به آن ۶۰ دقیقه است.
        </p>
        <p class="justified">
          <strong>4. تست اختلالات شخصیت MCMI:</strong>
          بصورت اختصاصی در زمینه تشخیص اختلالات شخصیت طراحی شده و خروجی بسیار
          دقیقی از انواع مختلف اختلالات شخصیت در اختیار متخصص بالینی قرار می
          دهد‌. این تست مناسب افراد ۱۸ سال به بالا است. تعداد سوالات این تست ۱۷۵
          و زمان تقریبی پاسخدهی به آن ۳۰ دقیقه است.
        </p>
        <p class="justified">
          <strong>5. تست شخصیت شناسی NEO:</strong>
          آزمون بسیار مشهور در زمینه سنجش پنج فاکتور اصلی شخصیت است. کاربرد اصلی
          این تست شخصیت شناسی و خودشناسی در زمینه روابط پیش از ازدواج و پیشرفت
          شغلی می باشد. این تست برای افراد ۱۷ تا ۷۹ سال مناسب است. تعداد سوالات
          این تست ۲۴۰ و زمان تقریبی پاسخدهی به آن ۱۵ دقیقه می باشد.
        </p>
        <p class="justified">
          <strong>6. تست شخصیت CATTELL:</strong>
          این تست ارزیابی جامعی از شانزده عامل شخصیت به عمل می آورد و اصلی ترین
          کاربرد آن تشخیص بالینی و طراحی مداخلات درمانی، مشاوره شغلی و پیش از
          ازدواج است. این تست برای افراد ۱۶ سال و بالاتر کاربرد دارد. تعداد
          سوالات این تست ۱۸۷ و زمان تقریبی پاسخدهی به آن ۲۰ دقیقه می باشد.
        </p>

        <p class="justified">
          <strong>7. تست طرحواره یانگ:</strong>
          یکی از معتبرترین تستها در زمینه سنجش و تشخیص طرحواره های ناسازگاز یا
          تله های زندگی است که توسط روانشناس معروف جفری یانگ طراحی و ابداع شده
          است. این تست برای افراد ۱۲ سال و بالاتر از آن کاربرد دارد. تعداد
          سوالات این تست ۹۰ و زمان تقریبی پاسخدهی به آن ۱۵ دقیقه می باشد.
        </p>

        <p class="justified">
          <strong>8. تست نیازهای گلاسر:</strong>
          یک آزمون بسیار کاربردی براساس تئوری انتخاب روانشناس معروف ویلیام گلاسر
          است که نیازهای اساسی پنج‌گانه افراد را شناسایی می کند و بین متخصصان
          سلامت روان در زمینه ارتقای روابط بین فردی، عاطفی و مشاوره پیش از
          ازدواج ابزاری کارآمد محسوب می شود. این تست برای افراد ۱۳ و بالاتر از
          آن کاربرد دارد. تعداد سوالات این تست ۳۵ و زمان تقریبی پاسخدهی به آن ۱۵
          دقیقه می باشد.
        </p>
        <p class="justified">
          <strong>9. تست فرزندپروری یانگ:</strong>
          این تست براساس نظریه طرحواره درمانی جفری یانگ و در زمینه ارزیابی سبک
          های مختلف فرزندپروری طراحی شده است. در واقع متخصص روانشناس به کمک این
          تست می تواند به ریشه های تحولی طرحواره های ناسازگار مراجع خویش آگاهی
          پیدا کند. این تست برای افراد ۱۲ سال و بالاتر از آن کاربرد دارد. تعداد
          سوالات این تست ۷۲ و زمان تقریبی پاسخدهی به آن ۱۵ دقیقه می باشد.
        </p>
        <p class="justified">
          <strong>10. تست هوش هیجانی (EQ):</strong>
          بارون، استاد روانشناسی دانشگاه تگزاس، یکی از پیشگامان سنجش هوش هیجانی
          (EQ) در دنیا محسوب می شود که با طراحی تست EQi پنج بعد کلی هوش هیجانی و
          پانزده فاکتور حیاتی در تنظیم احساسات و هیجانات را شناسایی کرد. کاربرد
          اصلی این تست آشنایی متخصصان و مراجعین نسبت به ابعاد متخلف هوش هیجانی
          در وجود خود و رشد و توسعه نقاط ضعف در این زمینه می باشد. این تست برای
          افراد ۱۸ سال و بالاتر از آن مناسب است. تعداد سوالات این تست ۹۰ و زمان
          تقریبی پاسخدهی به آن ۱۵ دقیقه می باشد.
        </p>
        <p class="justified">
          <strong>11. تست هوش گاردنر(کودک):</strong>
          دکتر گاردنر تکیه صرف بر ضریب هوشی در کودکان را گمراه کننده می پندارد و
          معتقد است هر کدام از کودکان ابعاد مختلف و متفاوتی از هوش و استعداد را
          دارا هستند. تست هوش چندگانه گاردنر یکی از معتبرترین ابزارهای هوش در
          سطح دنیا در زمینه سنجش هوش و استعداد شغلی و تحصیلی در کودکان می باشد.
          این تست برای کوکان ۷ تا ۱۲ سال کاربرد دارد. تعداد سوالات این تست ۴۸ و
          زمان تقریبی پاسخگویی ۳۰ دقیقه است.
        </p>

        <p class="justified">
          <strong>12. تست هوش گاردنر (نوجوان و بزرگسال):</strong>
          از طریق این تست می توانید نه جنبه مختلف هوش خود را شناسایی و با کمک
          متخصص مربوطه در زمینه ارتقای ابعاد مختلف هوش تمرینات لازم را انجام
          دهید. کاربرد اصلی این تست در زمینه استعدادیابی در زمینه های شغلی و
          تحصیلی است. حداقل سن لازم برای انجام این تست ۱۲ سال است. تعداد سوالات
          این تست ۸۰ و زمان تقریبی پاسخگویی ۳۰ دقیقه است.
        </p>

        <p class="justified">
          <strong>13. رغبت سنج شغلی و تحصیلی هالند:</strong>
          روانشناس مشهور آمریکایی جان هالند شش حوزه اصلی در ارزیابی علاقه ها و
          تمایلات شغلی افراد شناسایی کرد. شما براساس اینکه در کدامیک از این شش
          طبقه قرار می گیرید به لحاظ شخصیتی متناسب با شغل و حرفه خاصی هستید که
          نتایج این تست بهترین طبقه شغلی برای شما را معرفی می نماید. این تست
          برای افراد ۱۲ سال و بالاتر مناسب است و انجام تکالیف و چالش های ارائه
          شده در این تست حدودا ۱۵ دقیقه زمان می برد.
        </p>
      </div>
    </template>
    <template #footer>
      <div class="m-auto">
        <button
          class="btn btn-sm rounded btn-blueSite"
          @click="closeTestInformation"
        >
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
      </div>
    </template>
  </site-modal>

  <div id="wrapper">
    <header id="header" class="shadow">
      <div class="position-relative">
        <nav
          class="navbar navbar-expand-lg navbar-light justify-content-lg-between justify-content-md-inherit"
        >
          <div :class="isMobile ? 'w-100' : ''">
            <div
              id="menuBoxButton"
              :class="isMobile ? 'col-1' : 'd-inline-block'"
            >
              <!-- mobile menu button : show -->
              <button
                v-if="!isMobile"
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarMainNav"
                aria-controls="navbarMainNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
                style="border: 0"
              >
                <svg width="25" viewBox="0 0 20 20">
                  <path
                    d="M 19.9876 1.998 L -0.0108 1.998 L -0.0108 -0.0019 L 19.9876 -0.0019 L 19.9876 1.998 Z"
                  ></path>
                  <path
                    d="M 19.9876 7.9979 L -0.0108 7.9979 L -0.0108 5.9979 L 19.9876 5.9979 L 19.9876 7.9979 Z"
                  ></path>
                  <path
                    d="M 19.9876 13.9977 L -0.0108 13.9977 L -0.0108 11.9978 L 19.9876 11.9978 L 19.9876 13.9977 Z"
                  ></path>
                  <path
                    d="M 19.9876 19.9976 L -0.0108 19.9976 L -0.0108 17.9976 L 19.9876 17.9976 L 19.9876 19.9976 Z"
                  ></path>
                </svg>
              </button>
            </div>
            <!-- navbar : brand (logo) -->
            <div :class="getHeaderLogoClass">
              <a :class="isMobile ? '' : 'navbar-brand'" href="/">
                <img
                  v-if="!isMobile"
                  src="../../../assets/images/logo/logo-black-01.svg"
                  :style="[isMobile ? 'max-height: 80px;' : '']"
                  alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
                />
                <img
                  v-else
                  src="../../../assets/images/logo/logo-long-01.svg"
                  alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
                  :style="[
                    isMobile &&
                    !this.$router.currentRoute.value.path.includes('panel')
                      ? 'min-width: 200px;'
                      : 'width: 250px;',
                  ]"
                />
              </a>
              <a
                v-if="
                  this.$store.getters.isAuthenticated &&
                  isMobile &&
                  !this.$router.currentRoute.value.path.includes('panel')
                "
                href="#"
                aria-label="Account Options"
                id="dropdownAccountOptions"
                class="text-muted"
                :class="
                  isMobile
                    ? 'text-decoration-none text-dark p-1 m-1'
                    : 'btn btn-sm rounded bg-transparent btn-light shadow'
                "
                data-bs-toggle="dropdown"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <span class="group-icon mx-2">
                  <!-- <i class="fi fi-user-male fs-6"></i> -->
                  <svg
                    width="18px"
                    height="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-person-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    ></path>
                  </svg>
                  <svg
                    width="18px"
                    height="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    ></path>
                  </svg>
                </span>
                {{ getUserFullName }}
                <span
                  class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
                  v-if="getHasUnseenMessage"
                >
                  <span class="visually-hidden">پیام جدید</span>
                </span>
              </a>
              <a
                v-if="
                  !this.$store.getters.isAuthenticated &&
                  isMobile &&
                  !this.$router.currentRoute.value.path.includes('login')
                "
                @click="goToLoginOrReservePage"
                id=""
                class="rounded transition-hover-bottom mb-1 btn btn-danger"
                :class="
                  isMobile
                    ? 'text-decoration-none p-1 m-1 fs12px'
                    : 'btn btn-outline-danger'
                "
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span
                  class="bull bull-lg bg-white p-0 d-inline-block rounded-circle animate-pulse-warning me-1"
                ></span>
                خدمات درمانی کلینیک
              </a>
              <div
                aria-labelledby="dropdownAccountOptions"
                class="list-unstyled dropdown-menu dropdown-menu-clean dropdown-click-ignore end-0 py-2 rounded-xl"
                ref="dropdownAccountMenu"
                style="min-width: 215px"
              >
                <!-- <div class="dropdown-header px-4 mb-1 text-wrap fw-medium">
                  {{ getUserFullName }}
                </div> -->
                <!-- <div class="dropdown-divider mb-3"></div> -->
                <a
                  class="dropdown-item"
                  :href="'/panel/userPanel/' + getPersonID"
                  v-if="
                    !this.$router.currentRoute.value.path.includes(
                      'panel/userPanel'
                    )
                  "
                >
                  <span>پنل کاربری</span>
                </a>

                <a
                  class="dropdown-item"
                  :href="`/panel/userProfileTab/${$store.getters.userPersonID}`"
                  v-if="false"
                >
                  <span>حساب کاربری</span>
                </a>

                <a
                  class="dropdown-item"
                  :href="`/panel/messagesTab/${$store.getters.userPersonID}`"
                >
                  <span>
                    پیام های دریافتی
                    <span
                      class="position-absolute me-1 right-0 top-0 mt-1 p-1 bg-danger border border-light rounded-circle"
                      v-if="getHasUnseenMessage"
                    >
                      <span class="visually-hidden">پیام جدید</span>
                    </span>
                  </span>
                </a>

                <a
                  class="dropdown-item"
                  @click="showClientChooseDialog"
                  href="#"
                  v-if="checkMultipleClients()"
                >
                  <span>تغییر کاربر</span>
                </a>

                <a class="dropdown-item" @click="contactUsClick" href="#">
                  <span>ارتباط با مدیر فنی</span>
                </a>
                <div class="dropdown-divider mt-3"></div>
                <a
                  href="#"
                  title="Log Out"
                  class="dropdown-item mt-1 text-danger"
                  @click="logout"
                >
                  <i class="fi fi-power m-0"></i>
                  <span>خروج</span>
                </a>
              </div>
            </div>
          </div>

          <!-- Menu -->
          <!--

							Dropdown Classes (should be added to primary .dropdown-menu only, dropdown childs are also affected)
								.dropdown-menu-dark 		- dark dropdown (desktop only, will be white on mobile)
								.dropdown-menu-hover 		- open on hover
								.dropdown-menu-clean 		- no background color on hover
								.dropdown-menu-invert 		- open dropdown in oposite direction (left|right, according to RTL|LTR)
								.dropdown-menu-uppercase 	- uppercase text (font-size is scalled down to 13px)
								.dropdown-click-ignore 		- keep dropdown open on inside click (useful on forms inside dropdown)

								Repositioning long dropdown childs (Example: Pages->Account)
									.dropdown-menu-up-n100 		- open up with top: -100px
									.dropdown-menu-up-n100 		- open up with top: -150px
									.dropdown-menu-up-n180 		- open up with top: -180px
									.dropdown-menu-up-n220 		- open up with top: -220px
									.dropdown-menu-up-n250 		- open up with top: -250px
									.dropdown-menu-up 			- open up without negative class


								Dropdown prefix icon (optional, if enabled in variables.scss)
									.prefix-link-icon .prefix-icon-dot 		- link prefix
									.prefix-link-icon .prefix-icon-line 	- link prefix
									.prefix-link-icon .prefix-icon-ico 		- link prefix
									.prefix-link-icon .prefix-icon-arrow 	- link prefix

								.nav-link.nav-link-caret-hide 	- no dropdown icon indicator on main link
								.nav-item.dropdown-mega 		- required ONLY on fullwidth mega menu

								Mobile animation - add to .navbar-collapse:
								.navbar-animate-fadein
								.navbar-animate-fadeinup
								.navbar-animate-bouncein

						-->
          <div
            class="collapse navbar-collapse navbar-animate-fadein"
            id="navbarMainNav"
          >
            <!-- navbar : mobile menu -->
            <div class="navbar-xs d-none">
              <!-- .sticky-top -->
              <div class="row">
                <div class="col-3"></div>

                <!-- 
									Mobile Menu Logo 
									Logo : height: 70px max
								-->
                <div class="col-7">
                  <a class="navbar-brand" href="/">
                    <img
                      src="../../../assets/images/logo/logo_dark_150.png"
                      width="150"
                      height="50"
                      alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
                    />
                  </a>
                </div>
                <!-- mobile menu button : close -->
                <div class="col-2 pe-2">
                  <button
                    class="navbar-toggler pt-0 border-0 mx-0"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarMainNav"
                    aria-controls="navbarMainNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <svg width="20" viewBox="0 0 20 20">
                      <path
                        d="M 20.7895 0.977 L 19.3752 -0.4364 L 10.081 8.8522 L 0.7869 -0.4364 L -0.6274 0.977 L 8.6668 10.2656 L -0.6274 19.5542 L 0.7869 20.9676 L 10.081 11.679 L 19.3752 20.9676 L 20.7895 19.5542 L 11.4953 10.2656 L 20.7895 0.977 Z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <!-- /navbar : mobile menu -->

            <!-- navbar : navigation -->
            <ul class="navbar-nav">
              <!-- Menu -->
              <!--

									Dropdown Classes (should be added to primary .dropdown-menu only, dropdown childs are also affected)
										.dropdown-menu-dark 		- dark dropdown (desktop only, will be white on mobile)
										.dropdown-menu-hover 		- open on hover
										.dropdown-menu-clean 		- no background color on hover
										.dropdown-menu-invert 		- open dropdown in oposite direction (left|right, according to RTL|LTR)
										.dropdown-menu-uppercase 	- uppercase text (font-size is scalled down to 13px)
										.dropdown-click-ignore 		- keep dropdown open on inside click (useful on forms inside dropdown)

										Repositioning long dropdown childs (Example: Pages->Account)
											.dropdown-menu-up-n100 		- open up with top: -100px
											.dropdown-menu-up-n100 		- open up with top: -150px
											.dropdown-menu-up-n180 		- open up with top: -180px
											.dropdown-menu-up-n220 		- open up with top: -220px
											.dropdown-menu-up-n250 		- open up with top: -250px
											.dropdown-menu-up 			- open up without negative class


										Dropdown prefix icon (optional, if enabled in variables.scss)
											.prefix-link-icon .prefix-icon-dot 		- link prefix
											.prefix-link-icon .prefix-icon-line 	- link prefix
											.prefix-link-icon .prefix-icon-ico 		- link prefix
											.prefix-link-icon .prefix-icon-arrow 	- link prefix

										.nav-link.nav-link-caret-hide 	- no dropdown icon indicator on main link
										.nav-item.dropdown-mega 		- required ONLY on fullwidth mega menu

								-->

              <!-- home -->
              <li class="nav-item active">
                <a href="/" class="nav-link">صفحه اصلی</a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link"
                  data-toggle="dropdown"
                  href="#"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <!-- <i class="fi fi-pencil"></i> -->
                  نگارش‌های دکتر چاوشی
                </a>
                <div class="dropdown-menu py-0">
                  <a class="dropdown-item" href="/articles">
                    <i class="fi fi-layers"></i>
                    مقالات
                  </a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="/questionAnswers">
                    <!-- <i class="fi fi-round-question"></i> -->
                    پرسش و پاسخ
                  </a>
                </div>
              </li>
              <li class="nav-item"></li>

              <li class="nav-item">
                <a class="nav-link" href="/faq">
                  <!-- <i class="fi fi-list-checked"></i> -->
                  پرسش‌های متداول
                </a>
              </li>

              <!-- <li class="nav-item dropdown">
                <a
                  href="#"
                  id="mainNavBlog"
                  class="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  محتویات سایت
                </a>

                <div
                  aria-labelledby="mainNavBlog"
                  class="dropdown-menu dropdown-menu-clean dropdown-menu-hover dropdown-fadeinup"
                >
                  <ul class="list-unstyled m-0 p-0">
                    <li class="dropdown-item">
                      <a
                        class="dropdown-link prefix-icon-ignore"
                        href="/articles"
                      >
                        <i class="fi fi-layers"></i>
                        مقالات</a
                      >
                    </li>

                    <li class="dropdown-item">
                      <a
                        class="dropdown-link prefix-icon-ignore"
                        href="/questionAnswers"
                      >
                        <i class="fi fi-round-question"></i>
                        پرسش و پاسخ</a
                      >
                    </li>
                  </ul>
                </div>
              </li> -->

              <!-- about -->
              <li class="nav-item">
                <a
                  href="/about"
                  id=""
                  class="nav-link"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <!-- <i class="fi fi-squared-info"></i> -->
                  درباره ما
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="/contactUs"
                  id=""
                  class="nav-link"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <!-- <i class="fi fi-envelope"></i> -->
                  تماس با ما
                </a>
              </li>

              <li class="nav-item">
                <a
                  href="https://www.aparat.com/v/rty1lve"
                  id=""
                  class="nav-link"
                  v-if="!isMobile"
                  aria-haspopup="true"
                  aria-expanded="false"
                  target="_blank"
                >
                  راهنمای امکانات سایت
                </a>
              </li>
            </ul>
          </div>
          <!-- OPTIONS -->
          <!-- v-if="this.$router.currentRoute.value.path.includes('panel')" -->
          <ul
            v-if="!isMobile"
            class="list-inline list-unstyled mb-0 d-flex justify-content-between d-inline-block"
            :class="
              !this.$router.currentRoute.value.path.includes('panel')
                ? 'ulLoginAndReserve'
                : ''
            "
          >
            <li
              class="nav-item"
              v-if="
                isMobile &&
                !this.$router.currentRoute.value.path.includes('panel')
              "
              id="homeMobileButton"
            >
              <a
                type="button"
                class="me-2 text-decoration-none text-muted"
                href="/"
                style="border: 0"
              >
                <svg
                  width="18px"
                  height="18px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-house"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                  ></path>
                </svg>
              </a>
            </li>
            <li class="nav-item">
              <a
                v-if="
                  this.$router.currentRoute.value.path.includes('panel') &&
                  !isMobile &&
                  !this.$router.currentRoute.value.path.includes(
                    'invoiceList'
                  ) &&
                  !this.$router.currentRoute.value.path.includes('finalConfirm')
                "
                aria-label="Reserve Basket Options"
                id="dropdownRerserveBasketOptions"
                class="btn btn-light rounded bg-transparent transition-hover-bottom mb-1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <svg
                  width="18px"
                  height="18px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-cart2"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
                  ></path>
                </svg>
                <span
                  class="bg-danger badgheNotification"
                  v-if="
                    semiReserveList.length != 0 &&
                    !this.$router.currentRoute.value.path.includes(
                      'finalConfirm'
                    )
                  "
                ></span>
              </a>
              <!-- dropdown reserve basket -->
              <div
                aria-labelledby="dropdownRerserveBasketOptions"
                class="list-unstyled dropdown-menu dropdown-menu-clean dropdown-click-ignore end-0 py-2 rounded-xl"
                :class="semiReserveList.length == 0 ? 'p-5' : 'p-1'"
                ref="dropdownRerserveBasketOptions"
              >
                <div v-if="semiReserveList.length == 0">
                  <svg
                    width="32px"
                    height="32px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-cart-x d-block m-auto"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7.354 5.646 8.5 6.793l1.146-1.147a.5.5 0 0 1 .708.708L9.207 7.5l1.147 1.146a.5.5 0 0 1-.708.708L8.5 8.207 7.354 9.354a.5.5 0 1 1-.708-.708L7.793 7.5 6.646 6.354a.5.5 0 1 1 .708-.708z"
                    ></path>
                  </svg>
                  <h6 class="mt-3">جلسه‌ای به منظور رزرو وجود ندارد.</h6>
                </div>
                <div
                  v-if="
                    !this.$router.currentRoute.value.path.includes(
                      'finalConfirm'
                    ) &&
                    !this.$router.currentRoute.value.path.includes(
                      'invoiceList'
                    ) &&
                    semiReserveList.length != 0
                  "
                >
                  <div class="reserveBasket scrollable-styled-dark">
                    <div
                      class="card"
                      v-for="session in semiReserveList"
                      :key="session.sessionID"
                    >
                      <div class="p-1" style="background-color: #f3f3f3">
                        <button
                          @click="cancelReserveSession(session.sessionID)"
                          class="btn btn-outline-danger p-1 float-end"
                          style="font-size: 12px"
                        >
                          <svg
                            width="16px"
                            height="16px"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-trash"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                            ></path>
                            <path
                              fill-rule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                            ></path>
                          </svg>
                          حذف
                        </button>
                        <p class="m-0 p-1">
                          <span>{{ session.therapistName }}</span>
                          <small
                            class="gregorianDateClass"
                            style="unicode-bidi: embed"
                          >
                            ({{ getGregorianDateOfSession(session.date) }})
                          </small>
                          <span class="me-1">{{
                            getPersianDate(session.date)
                          }}</span>
                        </p>
                      </div>
                      <div class="row px-3 mt-2">
                        <div class="col-6">
                          <span class="fw-bold">نوع جلسه:</span>
                          <span>{{
                            session.sessionTypeID == 1 ? 'حضوری' : 'غیرحضوری'
                          }}</span>
                        </div>
                        <div class="col-6">
                          <span class="fw-bold">نوع درمان:</span>
                          <span>{{ session.therapyTypeTitle }}</span>
                        </div>
                        <div class="col-6">
                          <span class="fw-bold">از:</span>

                          <span>{{ getHourAndMinute(session.fromTime) }}</span>
                        </div>
                        <div class="col-6">
                          <span class="fw-bold">تا:</span>
                          <span>{{ getHourAndMinute(session.toTime) }}</span>
                        </div>
                        <div
                          class="col-6"
                          v-if="
                            !session.isCancelable || session.tariffTypeID == 2
                          "
                        >
                          <span class="fw-bold">قابل لغو:</span>
                          <span class="text-danger">
                            <i class="fi mdi-close"></i>
                            خیر
                          </span>
                        </div>
                        <div class="col-12">
                          <span class="fw-bold">تعرفه:</span>
                          <span class="me-2">
                            {{ session.tariffType }} -
                            <span v-if="session.discountPercent == 0">
                              {{ thousandSeprator(session.price, ',', '.') }}
                              {{ session.currencyTypeTitle }}
                            </span>
                            <span v-else>
                              {{
                                thousandSeprator(
                                  session.price -
                                    (session.price * session.discountPercent) /
                                      100,
                                  ',',
                                  '.'
                                )
                              }}
                              {{ session.currencyTypeTitle }}
                              <span
                                class="text-success"
                                v-if="session.discountPercent != 0"
                              >
                                (کد تخفیف)
                              </span>
                            </span>
                          </span>
                        </div>
                        <div class="col-12" v-if="session.sessionTypeID != 2">
                          <span class="fw-bold">آدرس:</span>
                          <span>{{ session.centerName }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="dropdown-divider mt-3"
                    style="border-top-color: gray"
                  ></div>
                  <div class="totalResultReserveBasket">
                    <button
                      class="btn btn-sm btn-danger"
                      style="font-size: 16px; float: left"
                      @click="
                        this.$router.push({
                          name: semiReserveList.every(s => s.therapyTypeTitle == 'تست') ? 'finalConfirmByTest' : 'finalConfirm',
                          params: { id: this.getPersonID },
                        })
                      "
                    >
                      <svg
                        width="16px"
                        height="16px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-check-circle-fill ms-1"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                        ></path>
                      </svg>
                      ثبت
                    </button>
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      style="font-size: 16px; float: left"
                      @click="getTotalReservedSessions()"
                    >
                      <svg
                        width="16px"
                        height="16px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-check-circle-fill ms-1"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                        ></path>
                      </svg>
                      بروزرسانی
                    </button>
                  </div>
                </div>
              </div>
            </li>
            <li
              v-if="
                !this.$store.getters.isAuthenticated &&
                !this.$router.currentRoute.value.path.includes('login')
              "
              class="nav-item"
            >
              <a
                @click="goToLoginOrReservePage"
                id=""
                class="rounded transition-hover-bottom mb-1 ms-1 btn btn-danger text-white"
                :class="
                  isMobile
                    ? 'text-decoration-none text-dark p-1 m-1'
                    : 'btn btn-outline-danger'
                "
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span
                  class="bull bull-lg bg-white p-0 d-inline-block rounded-circle animate-pulse-warning me-1"
                ></span>
                خدمات درمانی کلینیک
              </a>
            </li>
            <li
              v-if="
                this.$store.getters.isAuthenticated &&
                !(
                  this.$router.currentRoute.value.path.includes('panel') &&
                  isMobile
                )
              "
              class="list-inline-item m-1 dropdown"
            >
              <a
                href="#"
                aria-label="Account Options"
                id="dropdownAccountOptions"
                class="text-muted"
                :class="
                  isMobile
                    ? 'text-decoration-none text-dark p-1 m-1'
                    : 'btn btn-sm rounded bg-transparent btn-light shadow'
                "
                data-bs-toggle="dropdown"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <span class="group-icon mx-2">
                  <!-- <i class="fi fi-user-male fs-6"></i> -->
                  <svg
                    width="18px"
                    height="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-person-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    ></path>
                  </svg>

                  <svg
                    width="18px"
                    height="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    ></path>
                  </svg>
                </span>
                {{ getUserFullName }}
                <span
                  class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
                  v-if="getHasUnseenMessage"
                >
                  <span class="visually-hidden">پیام جدید</span>
                </span>
              </a>
              <!-- dropdown -->
              <div
                aria-labelledby="dropdownAccountOptions"
                class="list-unstyled dropdown-menu dropdown-menu-clean dropdown-click-ignore end-0 py-2 rounded-xl"
                ref="dropdownAccountMenu"
                style="min-width: 215px"
              >
                <!-- <div class="dropdown-header px-4 mb-1 text-wrap fw-medium">
                  {{ getUserFullName }}
                </div> -->
                <!-- <div class="dropdown-divider mb-3"></div> -->
                <a
                  class="dropdown-item"
                  :href="'/panel/userPanel/' + getPersonID"
                  v-if="
                    !this.$router.currentRoute.value.path.includes(
                      'panel/userPanel'
                    )
                  "
                >
                  <span>پنل کاربری</span>
                </a>

                <a
                  class="dropdown-item"
                  :href="`/panel/userProfileTab/${$store.getters.userPersonID}`"
                  v-if="false"
                >
                  <span>حساب کاربری</span>
                </a>

                <a
                  class="dropdown-item"
                  :href="`/panel/messagesTab/${$store.getters.userPersonID}`"
                >
                  <span>
                    پیام های دریافتی
                    <span
                      class="position-absolute me-1 right-0 top-0 mt-1 p-1 bg-danger border border-light rounded-circle"
                      v-if="getHasUnseenMessage"
                    >
                      <span class="visually-hidden">پیام جدید</span>
                    </span>
                  </span>
                </a>

                <a
                  class="dropdown-item"
                  @click="showClientChooseDialog"
                  href="#"
                  v-if="checkMultipleClients()"
                >
                  <span>تغییر کاربر</span>
                </a>

                <a class="dropdown-item" @click="contactUsClick" href="#">
                  <span>ارتباط با مدیر فنی</span>
                </a>
                <div class="dropdown-divider mt-3"></div>
                <a
                  href="#"
                  title="Log Out"
                  class="dropdown-item mt-1 text-danger"
                  @click="logout"
                >
                  <i class="fi fi-power m-0"></i>
                  <span>خروج</span>
                </a>
              </div>
            </li>
          </ul>
          <!-- /OPTIONS -->
        </nav>
      </div>
    </header>
    <!-- main content -->
    <div class="" style="min-height: 80vh">
      <router-view />
    </div>
    <!-- /main content -->

    <!-- Footer -->
    <footer
      id="footer"
      v-if="!this.$router.currentRoute.value.path.includes('panel')"
      class="bg-footer text-white"
    >
      <!-- footer cta -->
      <template
        v-if="!this.$router.currentRoute.value.path.includes('contactUs')"
      >
        <!-- <div
          class="container tet-white pt-5 pb-3 flex-row align-items-center"
          v-if="!isMobile"
        >
          <div class="row g-4 text-center">
            <div class="col-12 col-lg-2">
              <a href="/">
                <img
                  width="110"
                  height="38"
                  src="../../../assets/images/logo/logo-white-01.svg"
                  alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
                />
              </a>
            </div>
            <div class="col-12 col-lg-8">
            </div>
            <div class="col-12 col-lg-2">
              <a
                href="https://www.instagram.com/dr.behzad.chavooshi"
                class="btn btn-sm text-white transition-hover-top mb-2 rounded-circle bg-gray-700"
                rel="noopener"
                target="_blank"
                aria-label="instagram page"
                title="Instagram"
              >
                <i class="fi fi-social-instagram"></i>
              </a>

              <a
                href="https://www.linkedin.com/in/behzad-chavooshi-4b1436173"
                class="btn btn-sm text-white transition-hover-top mb-2 rounded-circle bg-gray-700"
                rel="noopener"
                target="_blank"
                aria-label="linkedin page"
                title="Linkedin"
              >
                <i class="fi fi-social-linkedin"></i>
              </a>
            </div>
          </div>
        </div> -->

        <!-- /footer cta -->

        <!-- line divider -->
        <hr class="bg-gray-500 my-0 container" />

        <div class="container p-3" v-if="!isMobile">
          <!-- <h4 class="h4 text-end mb-4">با ما در تماس باشید</h4> -->
          <div class="row g-4 justify-content-center">
            <div class="col-12 col-lg-4 text-end">
              <div class="small d-flex align-items-center">
                <svg
                  class="mx-3 flex-none"
                  height="24px"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  ></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <ul class="list-unstyled p-0 m-0 w-100">
                  <li>تـهران</li>
                  <li>بلـوار آفـریقا (جردن)</li>
                  <li>بالاتر از چهارراه اسفندیار، کوچه تور، پلاک ۴۶</li>
                  <li>کدپستی: 1915653936</li>
                </ul>
              </div>
            </div>
            <div class="col-12 col-lg-4 text-end">
              <div class="small d-flex align-items-center text-end">
                <svg
                  height="20px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-telephone-inbound mx-3 flex-none"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0zm-12.2 1.182a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                  ></path>
                </svg>
                <ul class="list-unstyled p-0 m-0 w-100">
                  <li>
                    <a href="tel:۰۲۱-۹۱۰۰۵۱۴۱" class="text-white text-dashed"
                      >۰۲۱-۹۱۰۰۵۱۴۱</a
                    >
                    <br />
                    <!-- <a href="tel:۰۲۱-۹۱۰۰۵۱۴۴" class="text-white text-dashed"
                      >۰۲۱-۹۱۰۰۵۱۴۴</a
                    > -->
                  </li>
                  <li>(همه روزه ۹ صبح تا ۹ شب)</li>
                </ul>
              </div>
            </div>

            <div class="col-12 col-lg-4 text-end">
              <div class="small d-flex align-items-center text-end">
                <svg
                  class="mx-3 flex-none"
                  height="24px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                  ></path>
                </svg>
                <ul class="list-unstyled p-0 m-0 w-100">
                  <li>
                    <a
                      href="mail:support@organicminded.org"
                      class="text-white text-dashed"
                    >
                      support@organicminded.org (انتقادات)
                    </a>
                  </li>
                  <li>
                    <a
                      href="mail:request@organicminded.org"
                      class="text-white text-dashed"
                    >
                      request@organicminded.org (ارسال رزومه)
                    </a>
                  </li>
                </ul>
              </div>
              <div class="mt-2 text-center">
                <a
                  href="https://www.instagram.com/dr.behzad.chavooshi"
                  class="btn btn-sm text-white transition-hover-top mb-2 rounded-circle bg-gray-700"
                  rel="noopener"
                  target="_blank"
                  aria-label="instagram page"
                  title="Instagram"
                >
                  <i class="fi fi-social-instagram"></i>
                </a>

                <a
                  href="https://www.linkedin.com/in/behzad-chavooshi-4b1436173"
                  class="btn btn-sm text-white transition-hover-top mb-2 rounded-circle bg-gray-700"
                  rel="noopener"
                  target="_blank"
                  aria-label="linkedin page"
                  title="Linkedin"
                >
                  <i class="fi fi-social-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr class="bg-gray-500 my-0 container" />
      </template>

      <div class="container pt-3 d-flex justify-content-center">
        <div class="text-center">
          <a @click="showCertificates('footer')">
            <img
              src="../../../assets/images/siteImages/footer_nezam_10.svg"
              class="filter-white"
              :class="isMobile ? 'w-50' : ''"
            />
          </a>
        </div>
        <div class="text-center">
          <a @click="showCertificates('footer')">
            <img
              src="../../../assets/images/siteImages/footer_behzisti_10.svg"
              class="filter-white"
              :class="isMobile ? 'w-50' : ''"
            />
          </a>
        </div>
        <div class="text-center">
          <a @click="showCertificates('footer')">
            <img
              src="../../../assets/images/siteImages/footer_javanan_10.svg"
              class="filter-white"
              :class="isMobile ? 'w-50' : ''"
            />
          </a>
        </div>
        <div :class="isMobile ? 'eeNamad-mobile' : 'eeNamad'" class="px-1">
          <a
            referrerpolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=485354&Code=Th31gFieDxoZqw9NqghquJDVMWTNpTyq"
            ><img
              referrerpolicy="origin"
              src="https://trustseal.enamad.ir/logo.aspx?id=485354&Code=Th31gFieDxoZqw9NqghquJDVMWTNpTyq"
              alt=""
              style="cursor: pointer"
              code="Th31gFieDxoZqw9NqghquJDVMWTNpTyq"
          /></a>
        </div>
      </div>

      <div class="mt-4 text-center">
        <!-- copyright -->
        <!-- <p class="small mb-0">&copy; 2022 My Company Inc.</p> -->
        <p class="smaller mb-0">
          کلیه حقوق این سایت متعلق به کلینیک ارگانیک مایندد می باشد
        </p>
      </div>
    </footer>
    <!-- /Footer -->
  </div>

  <div id="overlay-default" v-if="openSidePanel"></div>
  <aside
    id="aside-cart"
    ref="asidePanel"
    class="aside-custom-start bg-white shadow-xs h-auto d-flex flex-column align-items-stretch"
    :class="openSidePanel ? 'js-aside-show' : ''"
  >
    <div
      class="clearfix px-3 py-4 mb-1 border-bottom border-light shadow-xs bg-gray-200"
    >
      <div class="float-start ps-2 lh-1">
        <h4 class="fw-bold mb-0" :class="isMobile ? 'fs-6' : 'fs-5'">
          فهرست خدمات کلینیک ارگانیک مایندد
        </h4>
      </div>
      <a class="float-end" @click="closeSideBar" href="#">
        <svg width="17px" viewBox="0 0 20 20">
          <path
            class="fill-secondary"
            d="M 20.7895 0.977 L 19.3752 -0.4364 L 10.081 8.8522 L 0.7869 -0.4364 L -0.6274 0.977 L 8.6668 10.2656 L -0.6274 19.5542 L 0.7869 20.9676 L 10.081 11.679 L 19.3752 20.9676 L 20.7895 19.5542 L 11.4953 10.2656 L 20.7895 0.977 Z"
          ></path>
        </svg>
      </a>
    </div>

    <div
      id="aside-cart-container"
      class="d-flex flex-column align-items-stretch h-100 overflow-hidden"
    >
      <div class="w-100 shadow-xs">
        <div class="fs-6 border-bottom p-3">
          <a
            class="text-decoration-none m-0 text-danger"
            href="#"
            @click="reservingSessionFunction(true)"
          >
            <svg
              width="25px"
              height="25px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-calendar-check ms-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
              <path
                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
              ></path>
            </svg>
            <span class="animate-pulse-danger">جلسه درمانی</span>
          </a>
          <p class="fs11px link-muted mt-2">
            به منظور دریافت نوبت جلسه درمانی از این بخش می توانید اقدام نمایید
          </p>
        </div>
      </div>
      <div class="w-100 shadow-xs">
        <div class="fs-6 border-bottom p-3">
          <a
            class="text-decoration-none m-0 text-primary"
            href="#"
            @click="reservingTestSessionFunction(true)"
          >
            <svg
              width="25px"
              height="25px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-journal-check ms-2"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
              <path
                d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
              ></path>
              <path
                d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
              ></path>
            </svg>
            <span class="animate-pulse-primary">تست و ارزیابی</span>
          </a>
          <p class="fs11px link-muted mt-2">
            به منظور دریافت نوبت جلسه تست و ارزیابی از این بخش می توانید اقدام
            نمایید
          </p>
        </div>
      </div>

      <div class="w-100 shadow-xs">
        <div class="fs-6 border-bottom p-3">
          <a
            :href="`/panel/workshopTab/${$store.getters.userPersonID}/1`"
            class="text-decoration-none m-0 text-success"
          >
            <svg
              width="25px"
              height="25px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-people ms-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
              ></path>
            </svg>

            <span class="animate-pulse-success position-relative"
              >گروه درمانی
            </span>
          </a>
          <p class="fs11px link-muted mt-2">
            به منظور مشاهده گروه درمانی ها و ثبت نام در جلسات آنها از این بخش می
            توانید اقدام نمایید
          </p>
        </div>
      </div>

      <div class="w-100 shadow-xs">
        <div class="fs-6 border-bottom p-3">
          <a
            :href="`/panel/workshopTab/${$store.getters.userPersonID}/2`"
            class="text-decoration-none m-0 text-orange"
          >
            <svg
              width="25px"
              height="25px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-people ms-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
              ></path>
            </svg>

            <span class="animate-pulse-warning position-relative"
              >کارگاه آموزشی
            </span>
          </a>
          <p class="fs11px link-muted mt-2">
            به منظور مشاهده کارگاه های آموزشی و ثبت نام در جلسات آنها از این بخش
            می توانید اقدام نمایید
          </p>
        </div>
      </div>
    </div>
  </aside>
</template>
<script>
import { Modal } from 'bootstrap';
import { isMobile } from 'mobile-device-detect';
import axios from 'axios';
import LoadingSpinner from '../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import ComboBoxWithMessage from '../../../components/form/comboBoxWithMessage/ComboBoxWithMessage.vue';
import SearchableInput from '../../../components/form/searchableInput/SearchableInput.vue';
import FloatingInputWithMessage from '../../../components/form/floatingInputWithMessage/FloatingInputWithMessage.vue';
import ValidationSummery from '../../../components/form/errorBox/ValidationSummery.vue';

export default {
  data() {
    return {
      frFile: '',
      openSidePanel: false,
      originalScopeList: [],
      isDiscountSessionsModalShown: false,
      remainChar: 500,
      formHasError: false,
      formError: [],
      getTotalReserveCompeleted: false,
      validatedMessage: true,
      isScopeSelectDisabled: false,
      isSessionTypeSelectDisabled: false,
      // forcedTab: '',
      forcedRefresh: false,
      sessionPricecMode: 'normalSession',
      isMobile: isMobile,
      priceInformationModal: new Object(),
      certificateModal: new Object(),
      reservingModal: new Object(),
      reservingTestModal: new Object(),
      mainChooseClientModal: new Object(),
      contactUsModal: new Object(),
      discountSessionsModal: new Object(),
      logoutConformationModal: new Object(),
      testInformationModal: new Object(),
      reservingModalStatus: 'search',
      reservingTestModalStatus: 'search',
      scopeList: [],
      discountTariffPriceList: [],
      semiReserveList: [],
      therapyTypeList: [],
      originalTestTypeList: [],
      testTypeList: [],
      sessionTypeList: [],
      reservingEntity: {
        therapyTypeID: 0,
        sessionTypeID: 0,
        scopeIDs: [],
      },
      reservingTestEntity: {
        testTypeID: 0,
        sessionTypeID: 0,
      },
      showReservingEntity: {
        date: '',
      },
      entity: {
        clientCode: null,
        personID: null,
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: '',
        // fileName: null,
      },
      priceEntity: [],
    };
  },
  provide() {
    return {
      logout: this.logout,
      addSessionToSemiList: this.addSessionToSemiList,
      deleteSemiSession: this.removeSessionFromSemiList,
      semiReserveListCount: this.getSemiReserveListCount,
      semiReserveList: this.getSemiReserveList,
      clearSemiReserveList: this.clearSemiReserveList,
      showClientChooseDialog: this.showClientChooseDialog,
      cancelReserveSession: this.cancelReserveSession,
      contactUsClick: this.contactUsClick,
      sessionPricesInfo: this.sessionPricesInfo,
      getDiscountTariffPriceList: this.getDiscountTariffPriceList,
      showDiscountSessionsModal: this.showDiscountSessionsModal,
      getCurrentDiscountTariffPrice: this.getCurrentDiscountTariffPrice,
      showCertificates: this.showCertificates,
      reservingSessionFunction: this.reservingSessionFunction,
      reservingTestSessionFunction: this.reservingTestSessionFunction,
    };
  },
  components: {
    ComboBoxWithMessage,
    FloatingInputWithMessage,
    LoadingSpinner,
    SearchableInput,
    ValidationSummery,
  },
  computed: {
    getHeaderLogoClass() {
      return isMobile && !this.$router.currentRoute.value.path.includes('panel')
        ? 'text-center my-2 d-flex justify-content-between'
        : isMobile && this.$router.currentRoute.value.path.includes('panel')
        ? 'text-center opacity-25'
        : 'd-inline-block';
    },
    getUserFullName() {
      return this.$store.getters.userFullName;
    },
    getPersonID() {
      return this.$store.getters.userPersonID;
    },
    getHasUnseenMessage() {
      return (this.$store.getters.userHasUnseenMessage ?? 'false') === 'true';
    },
  },

  methods: {
    cancelMainChooseClientModal() {
      this.mainChooseClientModal.hide();
    },
    closeSideBar() {
      this.openSidePanel = false;
    },
    serviceBtnClick() {
      this.openSidePanel = true;
    },
    async sessionTypeForTestChanged(value) {
      await this.GetSessionsTariffPriceForNotice(14, value);
      this.reservingTestEntity.testTypeID = 0;
      let ids = [137, 188, 199];
      this.testTypeList = this.originalTestTypeList.filter(
        (m) => ids.indexOf(m.id) >= 0
      );

      if (value == 2) {
        ids = [124, 125, 126, 128, 129, 201, 202, 203, 209, 210, 211];
        let items = this.originalTestTypeList.filter(
          (m) => ids.indexOf(m.id) >= 0
        );
        this.testTypeList = this.testTypeList.concat(items);
      }
    },
    getDiscountTariffPriceList() {
      return this.discountTariffPriceList;
    },
    showDiscountSessionsModal() {
      this.isDiscountSessionsModalShown = true;
      this.discountSessionsModal.show();
    },
    discountSessionsModalClosed() {
      this.discountSessionsModal.hide();
      this.isDiscountSessionsModalShown = false;
    },
    cancelPriceInformationModal() {
      this.priceInformationModal.hide();
    },
    async sessionPricesInfo(sessionType) {
      if (sessionType == 'test') this.sessionPricecMode = 'test';
      let that = this;
      that.$refs.spinner.show();
      await axios
        .post('/CLC/Session/GetSessionsTariffPriceForNotice', {
          TherapyTypeID: sessionType == 'test' ? 14 : null,
          InternalExternal: that.$store.getters.isOverseas ? 2 : 1,
          IsPublicShow: 1,
        })
        .then((response) => {
          that.priceEntity = response.data;
          that.priceInformationModal.show();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          that.$refs.notification.show({
            type: 'error',
            title: 'عملیات دریافت قیمت و زمان جلسات با خطا مواجه گردید. ',
          });
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },
    async sessionTypeChanged(value) {
      await this.GetSessionsTariffPriceForNotice(
        this.reservingEntity.therapyTypeID,
        value
      );
    },
    async therapyTypeChanged(value) {
      this.reservingEntity.scopeIDs = [];
      this.scopeList = this.originalScopeList;
      this.isScopeSelectDisabled = false;
      this.isSessionTypeSelectDisabled = false;
      if (value != 1) {
        this.$refs.scopeInput.hideErrorMessage();
      }
      // اگر نوع درمان روانپزشکی بود حوزه باید روان‌بزشکی شود و غیرفعال
      if (value == 2) {
        this.scopeList = [
          {
            id: 8,
            label: 'روان‌پزشکی',
          },
        ];
        this.reservingEntity.sessionTypeID = 2;
        this.reservingEntity.scopeIDs = [8];
        this.isSessionTypeSelectDisabled = this.isScopeSelectDisabled = true;
      }
      // اگر نوع درمان روانسنجی بود حوزه باید روان‌سنجی(تست) شود و غیرفعال
      if (value == 14) {
        this.reservingEntity.scopeIDs = [7];
        this.isScopeSelectDisabled = true;
      }
      await this.GetSessionsTariffPriceForNotice(
        value,
        this.reservingEntity.sessionTypeID
      );
    },
    clearSemiReserveList() {
      this.semiReserveList = new Array();
    },
    getSemiReserveList() {
      return this.semiReserveList;
    },
    getSemiReserveListCount() {
      if (
        !this.getTotalReserveCompeleted &&
        this.$router.currentRoute.value.path.includes('finalConfirm') &&
        this.$router.currentRoute.value.path.includes('invoiceList')
      ) {
        return -1;
      }
      return this.semiReserveList.length;
    },

    async GetSessionsTariffPriceForNotice(therapyTypeID, sessionTypeID) {
      if (therapyTypeID == 0 || sessionTypeID == 0) return;
      0;
      let that = this;
      that.$refs.spinner.show();
      await axios
        .post('/CLC/Session/GetSessionsTariffPriceForNotice', {
          TherapyTypeID: therapyTypeID,
          SessionTypeID: sessionTypeID,
        })
        .then((response) => {
          that.priceEntity = response.data;
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: 'عملیات دریافت قیمت و زمان جلسات با خطا مواجه گردید. ',
          });
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },
    async cancelReserveSession(sessionID) {
      let errorMessagesResult = [];
      if (this.$store.getters.replacedSessionData) {
        this.removeSessionFromSemiList(sessionID);
        return errorMessagesResult;
      }
      let that = this;

      let toBeDeleteSession = that
        .getSemiReserveList()
        .find((f) => f.sessionID == sessionID);
      toBeDeleteSession =
        that
          .getSemiReserveList()
          .filter(
            (f) =>
              f.timeType == toBeDeleteSession.timeType &&
              f.data == toBeDeleteSession.date
          ).length > 1
          ? null
          : toBeDeleteSession;
      that.$refs.spinner.show();
      await axios
        .post('/CLC/Session/CancelSessionForSite', { id: sessionID })
        .then(() => {
          that.removeSessionFromSemiList(sessionID);
          that.$refs.notification.show({
            type: 'success',
            title: `جلسه مورد نظر با موفقیت حذف گردید.`,
          });
          if (
            that.$router.currentRoute.value.path.includes('sessionTableView')
          ) {
            if (toBeDeleteSession) {
              let elemnt = document.getElementById(
                'cell' + toBeDeleteSession.timeType + toBeDeleteSession.date
              );
              if (elemnt) elemnt.classList.remove('reservedBackColor');
            }
          }
        })
        .catch(async (response) => {
          await that.getTotalReservedSessions();
          response.response.data.errors.forEach((error) => {
            errorMessagesResult.push(error.errorMessage);
            that.$refs.notification.show({
              type: 'error',
              title: error.errorMessage,
            });
          });
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
      return errorMessagesResult;
    },
    getHourAndMinute(data) {
      return `${data.split(':')[0]}:${data.split(':')[1]}`;
    },
    getGregorianDateOfSession(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    thousandSeprator(number, seprator, decimalPointer) {
      // eslint-disable-next-line
      return thousandSeprator(number, seprator, decimalPointer);
    },
    addSessionToSemiList(session) {
      //CurrencyTypeID
      this.semiReserveList.push(session);
    },
    removeSessionFromSemiList(sessionID) {
      this.semiReserveList = this.semiReserveList.filter(
        (f) => f.sessionID != sessionID
      );
    },
    async reservingTestSessionFunction(fromLayout) {
      this.$refs.spinner.show();
      //دریافت نوع تست(موضوع با فیلتر حزوه تست)
      if (this.testTypeList.length == 0) await this.getTestTypeList();
      //دریافت نوع جلسه
      if (this.sessionTypeList.length == 0) await this.getSessionTypeList();
      this.$refs.spinner.hide();
      this.reservingTestModal.show();
      if (fromLayout) {
        this.closeSideBar();
      }

      await this.getCurrentDiscountTariffPrice();
      if (this.discountTariffPriceList.length != 0) {
        this.showDiscountSessionsModal();
      }
    },
    async getTestTypeList() {
      let that = this;
      that.$refs.spinner.show();
      await axios
        .post('/Basic/Topic/GetPublicByScopeIDs', [7])
        .then((response) => {
          that.originalTestTypeList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات نام تست‌ها با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },
    async reservingSessionFunction(fromLayout) {
      if (!this.$router.currentRoute.value.path.includes('panel')) {
        this.$refs.spinner.show();
        if (this.scopeList.length == 0) await this.getScopeList();
        if (this.therapyTypeList.length == 0) await this.getTherapyTypeList();
        if (this.sessionTypeList.length == 0) await this.getSessionTypeList();
        this.$refs.spinner.hide();
      }
      this.reservingModal.show();
      if (fromLayout) {
        this.closeSideBar();
      }
      await this.getCurrentDiscountTariffPrice();
      if (this.discountTariffPriceList.length != 0) {
        this.showDiscountSessionsModal();
      }
    },
    showCertificates() {
      this.certificateModal.show();
    },
    // getImgUrl(slideNumber) {
    //   var images = require.context(`../../../assets/images/siteImages/Certificates/${slideNumber}-Cert.jpg`, false, /\.jpg$/);
    //   return images('./' + pet);
    // },
    getImgUrl(slideNumber) {
      var images = require.context(
        '../../../assets/images/siteImages/Certificates',
        false,
        /\.jpg$/
      );
      return images('./' + slideNumber + '-Cert.jpg');
    },
    returnImgPath(slideNumber) {
      return `../../../assets/images/siteImages/Certificates/${slideNumber}-Cert.jpg`;
    },
    closedCertificateModal() {
      this.certificateModal.hide();
    },
    closedReservingTestModal() {
      this.priceEntity = [];
      this.reservingTestModal.hide();
      this.reservingTestEntity = new Object({
        testTypeID: 0,
        sessionTypeID: 0,
      });
      //اگر مراجع داخل کشور باشد شیوه برگزاری غیرحضوری باشد
      if (
        this.$store.getters.isOverseas == true &&
        this.$store.getters.isAuthenticated
      )
        this.reservingTestEntity.sessionTypeID = 2;
      this.sessionTypeForTestChanged(this.reservingTestEntity.sessionTypeID);
    },

    closedReservingModal() {
      this.priceEntity = [];
      this.reservingModal.hide();
      this.reservingEntity.therapyTypeID = 0;
      this.reservingEntity.sessionTypeID = 0;
      this.reservingEntity.scopeIDs = [];
      this.reservingEntity.scopeID = new Array();
      this.step1 = true;
      this.isScopeSelectDisabled = false;
      this.isSessionTypeSelectDisabled = false;
      //اگر مراجع داخل کشور باشد شیوه برگزاری غیرحضوری باشد
      if (
        this.$store.getters.isOverseas == true &&
        this.$store.getters.isAuthenticated
      )
        this.reservingEntity.sessionTypeID = 2;
    },
    logout() {
      this.logoutConformationModal.show();
    },
    confirmedLogout() {
      this.$store.dispatch('logout').then(() => {
        // this.$router.push({ name: 'home' });
        // window.location.reload();
        this.logoutConformationModal.hide();
        this.$router.push({ name: 'home' }).then(() => {
          window.location.reload();
        });
      });
      // this.$router.push('/');
      // this.$router.push({ name: 'home' });
    },
    logoutConfirmationClosed() {
      this.logoutConformationModal.hide();
    },
    returnBackStep() {
      this.reservingModalStatus = 'search';
    },
    returnTestBackStep() {
      this.reservingTestModalStatus = 'search';
    },

    async searchTestSessionButton() {
      let isValidEntity = true;
      if (
        this.reservingTestEntity.testTypeID == null ||
        this.reservingTestEntity.testTypeID == 0
      ) {
        this.$refs.testTypeInput.showErrorMessage();
        isValidEntity = false;
      }
      if (
        this.reservingTestEntity.sessionTypeID == null ||
        this.reservingTestEntity.sessionTypeID == 0
      ) {
        this.$refs.sessionTypeForTestInput.showErrorMessage();
        isValidEntity = false;
      }
      if (isValidEntity == false) return;
      if (this.$store.getters.isAuthenticated)
        this.goToLoginOrReserveTestPage();
      this.reservingTestModalStatus = 'result';
      // await this.getClosestValidSessions({
      //   therapyTypeID: 14,
      //   scopeIDs: [7],
      //   topicIDs: this.reservingTestEntity.testTypeID,
      //   sessionTypeID: this.reservingTestEntity.sessionTypeID,
      // });
    },
    goToLoginOrReservePage() {
      this.$store.dispatch('setFilterForPreReserving', this.reservingEntity);
      this.reservingModal.hide();
      this.reservingTestModal.hide();
      if (!this.$store.getters.isAuthenticated) {
        this.$router.push({
          name: 'login',
        });
      } else
        this.$router.push({
          name: 'sessionTableView',
          params: { id: this.getPersonID },
        });
    },
    goToLoginOrReserveTestPage() {
      this.$store.dispatch(
        'setFilterForPreTestReserving',
        this.reservingTestEntity
      );
      localStorage.setItem(
        'testName',
        this.testTypeList.find(
          (i) => i.id == this.reservingTestEntity.testTypeID
        ).label
      );
      this.reservingModal.hide();
      this.reservingTestModal.hide();
      if (!this.$store.getters.isAuthenticated) {
        this.$router.push({
          name: 'login',
        });
      } else
        this.$router.push({
          name: 'sessionTableView',
          params: { id: this.getPersonID },
        });
    },
    async searchButton() {
      let isValidEntity = true;
      if (
        this.reservingEntity.therapyTypeID == null ||
        this.reservingEntity.therapyTypeID == 0
      ) {
        this.$refs.therapyTypeInput.showErrorMessage();
        isValidEntity = false;
      }
      if (
        this.reservingEntity.sessionTypeID == null ||
        this.reservingEntity.sessionTypeID == 0
      ) {
        this.$refs.sessionTypeInput.showErrorMessage();
        isValidEntity = false;
      }
      if (
        this.reservingEntity.scopeIDs.length == 0 &&
        this.reservingEntity.therapyTypeID == 1
      ) {
        this.$refs.scopeInput.showErrorMessage();
        isValidEntity = false;
      }
      if (isValidEntity == false) return;
      //اگر لاگین کرده بود به رزرو برود
      if (this.$store.getters.isAuthenticated) this.goToLoginOrReservePage();
      this.reservingModalStatus = 'result';
      // await this.getClosestValidSessions(this.reservingEntity);
    },
    async getScopeList() {
      let that = this;
      await axios
        .get('/Basic/Scope/GetPublic')
        .then((response) => {
          that.scopeList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
          that.originalScopeList = that.scopeList;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات حوزه‌ها با خطا مواجه گردید.`,
          });
        });
    },
    async getTherapyTypeList() {
      let that = this;
      await axios
        .get('Basic/TherapyType/GetPublic')
        .then((response) => {
          that.therapyTypeList = response.data?.filter((f) => f.id != 14);
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات انواع جلسات با خطا مواجه گردید.`,
          });
        });
    },
    async getSessionTypeList() {
      let that = this;
      await axios
        .get('Basic/SessionType/GetPublic')
        .then((response) => {
          that.sessionTypeList = response.data;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات انواع برگزاری با خطا مواجه گردید.`,
          });
        });
    },
    async getCurrentDiscountTariffPrice() {
      let that = this;
      await axios
        .get(`FN/TariffPrice/GetCurrentDiscountTariffPrice`)
        .then((response) => {
          that.discountTariffPriceList = response.data;
          if (
            that.discountTariffPriceList.length != 0 &&
            that.$router.currentRoute.value.path.includes('userPanel')
          )
            that.showDiscountSessionsModal();
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات تخفیف جلسات خطا مواجه گردید.`,
          });
        });
    },
    async getClosestValidSessions(entity) {
      this.$refs.spinner.show();
      let that = this;
      await axios
        .post('CLC/Session/GetClosestValidSessions', entity)
        .then((response) => {
          that.showReservingEntity.date = response.data;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات انواع برگزاری با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    getPersianDate(date) {
      if (date == '') return '';
      // eslint-disable-next-line
      return new persianDate(new Date(date)).toLocale('en').format('L');
    },
    getFullPersianDate(date) {
      if (date == '') return '';
      // eslint-disable-next-line
      return new persianDate(new Date(date)).toLocale('fa').format('LLLLL');
    },
    checkMultipleClients() {
      let clientList = this.$store.getters.clientList;
      return clientList && clientList.length > 0;
    },
    getClientList() {
      let clientList = this.$store.getters.clientList;
      return clientList && clientList.length > 0 ? clientList : [];
    },
    showClientChooseDialog() {
      this.mainChooseClientModal.show();
    },

    async chooseClientButtonClick(item) {
      this.$refs.spinner.show();
      let that = this;
      sessionStorage.removeItem('replacedSessionData');

      that.$store
        .dispatch('setChangeClient', {
          personID: item.personID,
          firstName: item.firstName,
          lastName: item.lastName,
          isPartTime: item.isPartTime,
          hasUnseenMessage: item.hasUnseenMessage,
        })
        .then(async () => {
          that.$refs.spinner.hide();
          that.mainChooseClientModal.hide();
          if (that.$store.getters.userFullName) {
            that.$refs.notification.show({
              type: 'success',
              title: `${that.$store.getters.userFullName} خوش آمدید `,
            });

            that.$store
              .dispatch('setClientWithWallet', item.personID)
              .then(async () => {
                await this.getCurrentDiscountTariffPrice();
                that.$router.push({
                  name: 'userPanel',
                  params: { id: that.$store.getters.userPersonID },
                });
              });
          }
        })
        .catch(() => {
          that.$refs.spinner.hide();
        });
    },
    validatePhone(phone) {
      // eslint-disable-next-line
      phone = fixNumbers(phone);
      // eslint-disable-next-line
      return /^09\d{9}$/.test(phone);
    },
    validateEmail(email) {
      // eslint-disable-next-line
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    },
    messsageInput() {
      this.remainChar = 500 - (this.entity.message?.length ?? 0);
    },
    validate() {
      if (!this.entity.clientCode) {
        this.$refs.clientCodeInput.showErrorMessage();
        this.$refs.clientCodeInput.setFocus();
        return false;
      }
      if (!this.entity.name) {
        this.$refs.nameInput.showErrorMessage();
        this.$refs.nameInput.setFocus();
        return false;
      }
      if (!this.entity.subject) {
        this.$refs.subjectInput.showErrorMessage();
        this.$refs.subjectInput.setFocus();
        return false;
      }

      if (!this.entity.message) {
        this.validatedMessage = false;
        this.$refs.descriptionInput.focus();
        return false;
      } else {
        this.validatedMessage = true;
      }

      if (this.entity.phone && !this.validatePhone(this.entity.phone)) {
        this.$refs.phoneInput.showErrorMessage();
        this.$refs.phoneInput.setFocus();
        return false;
      }
      if (this.entity.email && !this.validateEmail(this.entity.email)) {
        this.$refs.emailInput.showErrorMessage();
        this.$refs.emailInput.setFocus();
        return false;
      }

      return true;
    },
    async getTotalReservedSessions() {
      let that = this;
      that.$refs.spinner.show();
      await axios
        .get(
          '/CLC/Session/GetSemiSiteReserveSessions?personID=' +
            this.$store.getters.userPersonID
        )
        .then((response) => {
          that.semiReserveList = response.data;
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات با خطا مواجه گردید`,
          });
        })
        .finally(() => that.$refs.spinner.hide());
    },
    resetEntity() {
      this.formHasError = false;
      this.formError = [];
      this.frFile = '';
      this.remainChar = 500;

      this.$refs.inputFileName.value = null;
      this.entity = new Object({
        clientCode: null,
        personID: null,
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: '',
        // fileName: null,
      });
      this.$refs.subjectInput.hideErrorMessage();
      this.$refs.emailInput.hideErrorMessage();
      this.$refs.phoneInput.hideErrorMessage();
      this.$refs.nameInput.hideErrorMessage();
      this.$refs.clientCodeInput.hideErrorMessage();
    },
    async fileReceiptInput(e) {
      if (e.target.files.length == 0) {
        return;
      }
      //   this.entity.fileName = e.target.files[0].name;
      this.$refs.inputFileName.value = e.target.files[0].name;
      this.frFile = e.target.files[0];
    },
    cancelContactUsModal() {
      this.resetEntity();
      this.contactUsModal.hide();
    },
    async confirmedContactUsModal() {
      if (this.entity.phone) {
        // eslint-disable-next-line
        this.entity.phone = fixNumbers(this.entity.phone);
      }

      if (!this.validate()) {
        return;
      }
      let that = this;
      that.$refs.spinner.show();
      that.entity.personID = this.$store.getters.userPersonID;
      let formData = new FormData();

      for (var key in this.entity) {
        formData.append(
          key,
          this.entity[key] != null ? this.entity[key] : null
        );
      }
      formData.append('File', this.frFile);
      await axios
        .post('/ST/ContactUs/CreateMessage', formData)
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            // errorMessages.forEach((item) => {
            //   that.$refs.notification.show({
            //     type: 'error',
            //     title: item,
            //   });
            // });
            that.formHasError = true;
            that.formError = errorMessages;
            return;
          }
          if (response?.data?.success) {
            that.$refs.notification.show({
              type: 'success',
              title: 'پیام شما با موفقیت ثبت شد',
            });
            this.cancelContactUsModal();
          }
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          that.$refs.notification.show({
            type: 'error',
            title: `ثبت اطلاعات با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },
    contactUsClick() {
      this.entity.name = this.$store.getters.clientFullName;
      this.entity.clientCode = this.$store?.getters?.clientCode;
      this.entity.phone = this.$store.getters.phone ?? '';
      this.entity.email = this.$store.getters.email ?? '';
      this.contactUsModal.show();
    },
    openTestInformation() {
      this.testInformationModal.show();
    },
    closeTestInformation() {
      this.testInformationModal.hide();
    },
  },
  async mounted() {
    this.logoutConformationModal = new Modal(
      document.getElementById('logoutConformationModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.discountSessionsModal = new Modal(
      document.getElementById('discountSessionsModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.priceInformationModal = new Modal(
      document.getElementById('priceInformationModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.certificateModal = new Modal(
      document.getElementById('certificateModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.reservingTestModal = new Modal(
      document.getElementById('reservingTestModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.reservingModal = new Modal(document.getElementById('reservingModal'), {
      keyboard: false,
      backdrop: 'static',
    });
    this.mainChooseClientModal = new Modal(
      document.getElementById('mainChooseClientModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );

    this.contactUsModal = new Modal(document.getElementById('contactUsModal'), {
      keyboard: false,
      backdrop: 'static',
    });

    this.testInformationModal = new Modal(
      document.getElementById('testInformationModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );

    document
      .getElementById('reservingModal')
      .children[0].classList.remove('modal-dialog-scrollable');
    document
      .getElementById('reservingTestModal')
      .children[0].classList.remove('modal-dialog-scrollable');

    //اگر در صفحه پنل بود، لیست جلسات در انتظار رزرو استخراج گردد
    if (this.$router.currentRoute.value.path.includes('panel')) {
      await this.getTotalReservedSessions();
    }
    let that = this;
    document.getElementById('btnUpload').addEventListener('click', function () {
      document.getElementById('formFile').click();
    });
    document.getElementById('formFile').oninput = (() => {}).bind(this);
    this.$messageHub.client.on('NewMessage', (message) => {
      if (message.personID == that.$store.getters.userPersonID) {
        that.forcedRefresh = !that.forcedRefresh;
        that.$store.dispatch('setHasUnseenMessage', {
          personID: that.$store.getters.userPersonID,
          hasUnseenMessage: 'true',
        });
      }
    });
    //اگر مراجع داخل کشور باشد شیوه برگزاری غیرحضوری باشد
    if (
      this.$store.getters.isOverseas == true &&
      this.$store.getters.isAuthenticated
    ) {
      this.reservingEntity.sessionTypeID = 2;
      this.reservingTestEntity.sessionTypeID = 2;
    }
    this.closeSideBar();
  },
};
</script>
<style>
.totalResultReserveBasket {
  width: 100%;
  padding: 10px;
  height: 50px;
}
.reserveBasket {
  max-width: 400px;
  max-height: 400px;
  top: unset;
  left: 10px !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.badgheNotification {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  display: inline-block;
  position: absolute;
  top: 10px;
  left: 30px;
  /* animation: blinkNotification 2s infinite; */
}
.btn.rounded-circle > svg {
  left: unset !important;
  right: 25% !important;
  top: unset !important;
}

.serviceButtonContainer {
  bottom: 40px;
  width: 40px;
  height: 40px;
  background-color: rgb(245, 245, 245);
  box-shadow: -3px -3px 20px gray;
  border-radius: 10px;
  position: fixed;
  left: 60px;
  z-index: 99;
  color: transparent;
  transition: width 0.3s, height 0.2s, color 0.5s;
}

#serviceBtn {
  border-radius: 30%;
  padding: 8px 10px;
  position: absolute;
  z-index: 99;
  font-size: 20px;
  cursor: pointer;
  bottom: -5px;
  right: -5px;
  animation: zoom-in-zoom-out 2.9s ease infinite;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
  transition: all 0s, border-radius 0.5s, padding 0s;
}
#serviceBtn {
  background-color: #f64e60;
  color: white;
  border-color: #f84f60ce;
}

#serviceBtn + div {
  display: none;
}

.reserveDescription {
  display: none;
}
.reserveDescription > p {
  opacity: 0;
  transition: all 0.2s;
}
.reserveDescription button {
  display: none;
  opacity: 0;
  transition: all 1s ease-in;
}
#serviceBtn ~ i {
  display: none;
}

#serviceBtn::after {
  opacity: 0;
  background: #f64e60;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: '';
  height: 100%;
  width: 100%;
  border-radius: 100%;
  -webkit-animation-name: ripple;
  animation-name: ripple;
  -webkit-animation-duration: 3s;
  animation-duration: 3s;
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  z-index: -1;
}

.carousel__prev {
  height: 100%;
}
.bg-footer {
  background-color: #3d4964 !important;
}
#wrapper {
  height: 100%;
}
.eeNamad {
  width: 100px;
  height: 100px;
  line-height: 0;
}
.eeNamad-mobile {
  width: 50px;
  height: 50px;
  line-height: 0;
}
@-webkit-keyframes ripple {
  from {
    opacity: 1;
    transform: scale3d(0.75, 0.75, 1);
  }
  to {
    opacity: 0;
    transform: scale3d(2, 2, 1);
  }
}
@keyframes ripple {
  from {
    opacity: 1;
    transform: scale3d(0.75, 0.75, 1);
  }
  to {
    opacity: 0;
    transform: scale3d(2, 2, 1);
  }
}
@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>
